import "./ShowAllEventsButton.css";

import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { ArrowIcon } from "~/components/Base/ArrowIcon/ArrowIcon";
import { useFetchEvents } from "~/hooks/api/event/useFetchEvents";

export function ShowAllEventsButton() {
  const { t } = useTranslation();
  const { events, isLoading, error } = useFetchEvents();

  if (isLoading || error || !events?.length) {
    return null;
  }

  return (
    <Link
      to="/events"
      className="show-all-events"
      data-testid="show-all-events-button"
    >
      <span className="show-all-events__label">
        {t("events.show_all_events")}
      </span>
      <ArrowIcon className="show-all-events__icon" />
    </Link>
  );
}
